export function getAttribution() {
  const match = document.cookie.match(/(?:^|; )_site_attr=([^;]*)/)
  if (!match) {
    return null
  }

  try {
    return JSON.parse(decodeURIComponent(match[1]))
  } catch (e) {
    return null
  }
}
